import React from 'react';
import * as Icons from 'lucide-react';

const GlassCard = ({ 
  icon, 
  title, 
  description, 
  highlight = false,
  children,
  className = '',
  ...props 
}) => {
  const IconComponent = icon ? Icons[icon] : null;

  return (
    <div
      className={`card-glass relative overflow-hidden group ${
        highlight ? 'border-violet-500/30' : ''
      } ${className}`}
      {...props}
    >
      {/* Highlight gradient overlay */}
      {highlight && (
        <div 
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
          style={{
            background: 'radial-gradient(circle at top right, rgba(124, 58, 237, 0.1) 0%, transparent 50%)',
          }}
        />
      )}
      
      {IconComponent && (
        <div 
          className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 transition-all duration-300 ${
            highlight 
              ? 'bg-violet-500/20 text-violet-400' 
              : 'bg-white/5 text-slate-400 group-hover:bg-violet-500/10 group-hover:text-violet-400'
          }`}
        >
          <IconComponent size={24} />
        </div>
      )}
      
      {title && (
        <h3 className="text-xl font-semibold text-white mb-3">
          {title}
        </h3>
      )}
      
      {description && (
        <p className="text-slate-400 leading-relaxed">
          {description}
        </p>
      )}
      
      {children}
    </div>
  );
};

export default GlassCard;
